export function isDeclaredEmptyChain(contextName, rawContexts) {
  const declared = contextName ? rawContexts?.[contextName] : null;
  return Boolean(declared?.sourceContext && declared.sourceField);
}
